/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量10
 * @export
 * @interface Col10
 */
export interface Col10 {
}

/**
 * Check if a given object implements the Col10 interface.
 */
export function instanceOfCol10(value: object): value is Col10 {
    return true;
}

export function Col10FromJSON(json: any): Col10 {
    return Col10FromJSONTyped(json, false);
}

export function Col10FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col10 {
    return json;
}

export function Col10ToJSON(json: any): Col10 {
    return Col10ToJSONTyped(json, false);
}

export function Col10ToJSONTyped(value?: Col10 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

